module.exports = __webpack_public_path__ + "static/media/basket.b46825f6.png";